import { render } from "./UserUpdateDialog.vue?vue&type=template&id=2497c052"
import script from "./UserUpdateDialog.vue?vue&type=script&lang=js"
export * from "./UserUpdateDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__